// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// haversineMiles — great-circle (straight-line) distance in miles between two
// latitude/longitude points. Pure math, no API, no network — runs in
// microseconds. Powers the #205 Stop Distance recommender gate (Brandon chose
// the math approach over per-pair Google Distance Matrix calls).
//
// Straight-line ("as the crow flies"); real road distance is longer, which the
// caller approximates with a road-factor multiplier (see installerStopDistance).
//
// Returns NaN if any coordinate is non-finite (caller treats NaN as
// "can't measure" → fails open).
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// Mean Earth radius in miles (IUGG mean radius 6371.0088 km / 1.609344).
const EARTH_RADIUS_MILES = 3958.7613;

const toRad = (deg) => (deg * Math.PI) / 180;

export function haversineMiles(lat1, lon1, lat2, lon2) {
  const a1 = Number(lat1);
  const o1 = Number(lon1);
  const a2 = Number(lat2);
  const o2 = Number(lon2);
  if (![a1, o1, a2, o2].every(Number.isFinite)) return NaN;

  const dLat = toRad(a2 - a1);
  const dLon = toRad(o2 - o1);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a1)) * Math.cos(toRad(a2)) * Math.sin(dLon / 2) ** 2;
  // clamp to 1 to guard against tiny FP overshoot at antipodes
  return 2 * EARTH_RADIUS_MILES * Math.asin(Math.min(1, Math.sqrt(h)));
}
